<template>
  <section class="build-with-us mr-n5">
    <div class="build-with-us__bg build-with-us__bg__pos1"></div>
    <div class="build-with-us__bg build-with-us__bg__pos2"></div>
    <div class="tw-flex tw-flew-row tw-flex-wrap lg:tw-flex-nowrap">
      <div class="tw-basis-full lg:tw-basis-5/12">
        <div class="tw-mr-5 tw-mb-5">
          <i18n-t
            keypath="build-your-partnership-with-us"
            tag="h2"
            class="tw-text-3xl md:tw-text-4xl lg:tw-text-5xl xl:tw-text-[80px] !tw-font-bold !tw-leading-tight"
          >
            <br />
            <br />
          </i18n-t>
          <div class="tw-hidden lg:tw-block tw-mt-20">
            <UIButton class="tw-btn-lg md:tw-btn-xl tw-uppercase" theme="secondary-1" @click="onTouched"
              >{{ $t('get-in-touch') }}<template #append-inner><svgo-common-arrow-white class="tw-w-2" /> </template
            ></UIButton>
          </div>
        </div>
      </div>
      <div class="tw-basis-full lg:tw-basis-7/12">
        <div class="tw-relative">
          <NuxtImg class="tw-w-full tw-min-w-[418px]" src="/res/img/cases/partnership-artwork.png"> </NuxtImg>
          <div class="tw-pt-5 tw-block lg:tw-hidden tw-absolute tw-bottom-0 tw-left-0">
            <UIButton theme="secondary-1" class="tw-btn-lg md:tw-btn-xl tw-uppercase" @click="onTouched"
              >{{ $t('get-in-touch') }} <template #append-inner><svgo-common-arrow-white class="tw-w-2" /> </template
            ></UIButton>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script setup lang="ts">
  const zenDesk = useZenDesk()
  const onTouched = () => {
    zenDesk.onToggle()
  }
</script>
<style scoped lang="scss">
  .build-with-us {
    position: relative;
    overflow: hidden;

    &__bg {
      position: absolute;
      width: 300px;
      height: 300px;
      background: url('/res/img/home/pattern.png');
      background-size: contain;
      background-position: center center;
      background-repeat: no-repeat;

      &__pos1 {
        top: 90px;
        left: -10%;
      }

      &__pos2 {
        top: 0;
        right: -10%;
      }
    }
  }
</style>
